import { Button, Grid, Link, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUtilityState,
  setExtraData,
} from "../../../../../features/utilities/utilitySlice";
import { selectMyContractsState } from "../../../../../features/myContracts/myContractsSlice";
import { useNavigate } from "react-router-dom";
import { selectPaymentsState } from "../../../../../features/payments/paymentsSlice";
import { useState } from "react";
import { makeStyles } from "@mui/styles";
import colors from "../../../../colors";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { texts } from "../../../../general/texts";
import ButtonGroup from "../../../../general/ButtonGroup";
import { useEffect } from "react";
import { sendGeneralRequest } from "../../../../../features/generalRequest";
import InsuranceForOthersView from "./searchMethod/InsuranceForOthersView";
import moment from "moment";
import PrimView from "./searchMethod/PrimView";
import DefaultView from "./searchMethod/DefaultView";

const Siguracione = (props) => {
  debugger
  const dispatch = useDispatch();
  const utilitySliceState = useSelector(selectUtilityState);
  const myContractsSliceState = useSelector(selectMyContractsState);
  const navigate = useNavigate();
  const paymentsSliceState = useSelector(selectPaymentsState);
  const [franchise, setFranchise] = useState("");
  const [zone, setZone] = useState("");
  const [section, setSection] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [birthDate, setBirthDate] = useState(null);
  const [name, setName] = useState("");
  const [surName, setSurName] = useState("");
  const [fathersName, setFathersName] = useState("");
  const [personalNo, setPersonalNo] = useState("");
  const [gender, setGender] = useState("");
  const [primView, setPrimView] = useState(false);
  const [selectedPrim, setSelectedPrim] = useState({
    prim: "",
    serviceName: "",
  });


  const searchMethods =
    props.userInfoSliceState.accountType === 3
      ? [{ display: "Personal", value: "2" }]
      : [
          { display: "Personal", value: "1" },
          { display: "Për dikë tjetër", value: "2" },
        ];

  const [state, setState] = React.useState({
    utilityName: props.utilityName,
    selectedSearchMethod: searchMethods[0].value,
    token: props.globalDataSliceState.token,
  });

  const getSearchMethodValue = (value) => {
    setState({
      ...state,
      selectedSearchMethod: value,
    });
  };

  useEffect(() => {
    dispatch(
      sendGeneralRequest({
        request: { token: state.token },
        baseUrlKey: "services",
        endpoint: "GetFranshizaSHU",
      })
    );
  }, []);

  useEffect(() => {
    if (
      props.utilitySliceState.franchaise &&
      props.utilitySliceState.franchaise.length === 1
    ) {
      setFranchise(props.utilitySliceState.franchaise[0]);
      dispatch(
        sendGeneralRequest({
          request: {
            token: state.token,
            franshiza: props.utilitySliceState.franchaise[0],
            shuTransactionId: props.utilitySliceState.transactionId,
          },
          baseUrlKey: "services",
          endpoint: "GetZonaSHU",
        })
      );
    }
  }, [props.utilitySliceState.franchaise]);

  const handleFranchiseChange = (e) => {
    const selectedFranchise = e.target.value;
    setFranchise(selectedFranchise);
    dispatch(
      sendGeneralRequest({
        request: {
          token: state.token,
          franshiza: selectedFranchise,
          shuTransactionId: props.utilitySliceState.transactionId,
        },
        baseUrlKey: "services",
        endpoint: "GetZonaSHU",
      })
    );
  };

  const handleZoneChange = (e) => {
    const selectedZone = e.target.value;
    setZone(selectedZone);
    dispatch(
      sendGeneralRequest({
        request: {
          token: state.token,
          zona: selectedZone,
          shuTransactionId: props.utilitySliceState.transactionId,
        },
        baseUrlKey: "services",
        endpoint: "GetSeksioneSHU",
      })
    );
  };

  const handleGetPrime = () => {
    dispatch(
      sendGeneralRequest({
        request: {
          token: state.token,
          seksioni: section,
          startDate: moment(dateRange[0]).format("YYYY-MM-DD"),
          endDate: moment(dateRange[1]).format("YYYY-MM-DD"),
          dateOfBirth:
            birthDate === null ? "" : moment(birthDate).format("YYYY-MM-DD"),
          shuTransactionId: props.utilitySliceState.transactionId,
          isPersonal: state.selectedSearchMethod === "1" ? true : false,
        },
        baseUrlKey: "services",
        endpoint: "GetPrimSHU",
      })
    );
    setPrimView(true);
  };

  const handleStartTransaction = () => {
    dispatch(
      sendGeneralRequest({
        request: {
          token: state.token,
          transID: props.utilitySliceState.transactionId,
          isPersonal: state.selectedSearchMethod === "1" ? true : false,
          primi: parseFloat(selectedPrim.prim),
          name: name,
          surname: surName,
          fathersName: fathersName,
          personalNo: personalNo,
          gender: gender,
          service: selectedPrim.serviceName,
        },
        baseUrlKey: "services",
        endpoint: "StartTransactionSHU",
      })
    );
    dispatch(
      setExtraData({
        prim: selectedPrim.prim,
        service: selectedPrim.serviceName,
      })
    );
  };

  const handleSectionChange = (e) => {
    setSection(e.target.value);
  };

  const handleBirthDateChange = (newValue) => {
    setBirthDate(newValue);
  };

  const isAnyFieldEmptyOrNull = () => {
    if (state.selectedSearchMethod === "1") {
      return (
        franchise === "" ||
        zone === "" ||
        section === "" ||
        dateRange[0] === null ||
        dateRange[1] === null ||
        fathersName === ""
      );
    } else if (state.selectedSearchMethod === "2") {
      return (
        franchise === "" ||
        zone === "" ||
        section === "" ||
        birthDate === null ||
        name === "" ||
        surName === "" ||
        fathersName === "" ||
        personalNo === "" ||
        gender === ""
      );
    }

    return false;
  };

  const selectedButtonStyle = {
    backgroundColor: colors.lightOrange,
    color: colors.orange,
    width: "150px",
    height: "40px",
    fontFamily: "GerberaBold",
    textTransform: "none",
    fontSize: "1rem",
    border: "2px solid" + colors.orange,
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: colors.lightOrange,
    },
    "@media (max-width: 899px)": { width: "130px", height: "40px" },
  };

  const defaultButtonStyle = {
    backgroundColor: colors.lightBlue,
    width: "150px",
    height: "40px",
    borderRadius: "10px",
    textTransform: "none",
    fontFamily: "GerberaLight",
    fontSize: "1rem",
    color: colors.darkBlue,
    "&:hover": {
      backgroundColor: colors.lightOrange,
    },
    "@media (max-width: 899px)": { width: "130px", height: "40px" },
  };

  const useStyles = makeStyles({
    mainGrid: {
      padding: "5%",
      paddingTop: "3%",
    },
    utilityName: {
      color: colors.orange,
      fontSize: "1.5rem",
      fontFamily: "GerberaBold",
      paddingTop: "3%",
      paddingLeft: "2%",
    },
    headerBox: {
      backgroundColor: colors.cyan,
      borderRadius: "100%",
      width: "70px",
      height: "70px",
    },
    fieldTitle: {
      color: colors.darkBlue,
      fontSize: "1.2rem",
      fontFamily: "GerberaBold",
      textAlign: "left",
    },
    button: {
      width: "100%",
      color: colors.white,
      fontSize: "1rem",
      textTransform: "none",
      background: colors.gradientOrange,
      fontFamily: "GerberaBold",
    },
    buttonGrid: {
      marginTop: 0,
      paddingBottom: 0,
    },
    image: {
      width: "45%",
    },
    textField: {
      width: "100%",
    },
  });

  const classes = useStyles();

  return (
    <Grid container item className={classes.mainGrid} rowSpacing={3}>
      <Grid container item md={2} xs={2} mt={2}>
        <Link
          component={"button"}
          onClick={() => {
            navigate(-1);
          }}
        >
          <ArrowBackIosNewIcon color="warning" />
        </Link>
      </Grid>
      <Grid container item md={12} xs={12}>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className={classes.headerBox}
        >
          <img src={props.utilityInfo?.logoPathNew} className={classes.image} />
        </Grid>
        <Typography className={classes.utilityName}>
          {texts["travel-health"]}
        </Typography>
      </Grid>
      {primView ? (
        <PrimView
          primView={primView}
          setPrimView={setPrimView}
          value={`${selectedPrim.prim}-${selectedPrim.serviceName}`}
          onChange={(e) => {
            const [prim, serviceName] = e.target.value.split("-");
            setSelectedPrim({ prim, serviceName });
          }}
          handleStartTransaction={() => handleStartTransaction()}
          props={props}
          classes={classes}
          navigate={navigate}
          utilitySliceState={props.utilitySliceState}
          selectedPrim={selectedPrim}
        />
      ) : (
        <>
          <Grid container item md={12} xs={12}>
            <Typography className={classes.fieldTitle}>
              {texts["prompt-choose-insurance-type"]}
            </Typography>
          </Grid>
          <Grid
            container
            item
            md={12}
            xs={12}
            justifyContent="flex-start"
            columnSpacing={5}
            rowSpacing={3}
          >
            <ButtonGroup
              defaultButtonStyle={defaultButtonStyle}
              selectedButtonStyle={selectedButtonStyle}
              state={searchMethods}
              sendValue={getSearchMethodValue}
            />
          </Grid>
          <Grid container item rowSpacing={3}>
            <DefaultView
              franchise={franchise}
              handleFranchiseChange={handleFranchiseChange}
              classes={classes}
              props={props}
              zone={zone}
              handleZoneChange={handleZoneChange}
              section={section}
              handleSectionChange={handleSectionChange}
              dateRange={dateRange}
              setDateRange={setDateRange}
              fathersName={fathersName}
              setFathersName={(e) => setFathersName(e.target.value)}
            />
            {state.selectedSearchMethod === "2" && (
              <InsuranceForOthersView
                birthDate={birthDate}
                handleBirthDateChange={handleBirthDateChange}
                classes={classes}
                name={name}
                setName={(e) => setName(e.target.value)}
                surName={surName}
                setSurName={(e) => setSurName(e.target.value)}
                fathersName={fathersName}
                setFathersName={(e) => setFathersName(e.target.value)}
                personalNo={personalNo}
                setPersonalNo={(e) => setPersonalNo(e.target.value)}
                gender={gender}
                setGender={(e) => setGender(e.target.value)}
              />
            )}
            <Grid item md={12} xs={12} className={classes.buttonGrid}>
              <Button
                disabled={
                  utilitySliceState.isLoading || isAnyFieldEmptyOrNull()
                }
                onClick={() => handleGetPrime()}
                sx={{
                  width: "100%",
                  color: colors.white,
                  fontSize: "1rem",
                  textTransform: "none",
                  background: colors.gradientOrange,
                  fontFamily: "GerberaBold",
                }}
              >
                {texts["title-get-prim"]}
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Siguracione;
